import FinanceSerializer from './base';
import { isEmpty } from '@ember/utils';

export default class Discrepancy extends FinanceSerializer {
  normalize(modelClass, payload) {
    payload.amount = ((payload.amount ?? 0) / 100).toFixed(2);
    return super.normalize(...arguments);
  }

  serialize() {
    let hash = super.serialize(...arguments);
    hash.amount = Math.round(hash.amount * 100);
    if (!isEmpty(hash.tillSessionId)) {
      hash.tillSessionId = parseInt(hash.tillSessionId, 10);
    }
    if (!isEmpty(hash.depositSlipId)) {
      hash.depositSlipId = parseInt(hash.depositSlipId, 10);
    }
    return hash;
  }
}
